/* Ayudate · Chequeo en vivo de disponibilidad de usuario
   Se usa tanto en FormTutor.jsx como en CrearCuentaEstudiante.jsx: debounce
   de 400 ms para no pegarle al servidor en cada tecla, y solo consulta si
   ya hay algo que valga la pena chequear (2+ caracteres). */

import { useEffect, useRef, useState } from "react";
import { api } from "../api";

const ESPERA_MS = 400;
const MIN_LARGO = 2;

export function useDisponibilidadUsuario(usuario) {
  const [estado, setEstado] = useState("vacio");   // vacio | corto | verificando | disponible | ocupado | error
  const contador = useRef(0);

  useEffect(() => {
    const t = (usuario || "").trim();
    if (!t) { setEstado("vacio"); return; }
    if (t.length < MIN_LARGO) { setEstado("corto"); return; }

    setEstado("verificando");
    const propio = ++contador.current;
    const temporizador = setTimeout(() => {
      api.verificarUsuarioDisponible(t)
        .then((disponible) => {
          if (contador.current !== propio) return;   // ya se escribió otra cosa mientras tanto
          setEstado(disponible ? "disponible" : "ocupado");
        })
        .catch(() => {
          if (contador.current === propio) setEstado("error");
        });
    }, ESPERA_MS);

    return () => clearTimeout(temporizador);
  }, [usuario]);

  return estado;
}
